import { render, staticRenderFns } from "./countriesInterview.vue?vue&type=template&id=e89d8c3c"
import script from "./countriesInterview.vue?vue&type=script&lang=js"
export * from "./countriesInterview.vue?vue&type=script&lang=js"
import style0 from "./countriesInterview.vue?vue&type=style&index=0&id=e89d8c3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports